import { API, API_GET_ID } from "../../../Config";

export const GetSingleRecipe = (id) => {
  return API_GET_ID(API.SingleRecipe, id);
};
